import { createSelector } from "reselect"
import { NORMALIZATION } from "helpers/segments"
import { getIsActive, getSelectedTypeId, getNormalization } from "./index"
import { getSegment } from "./segment"
import { getEffectiveNormalization } from "./filter-scope"

const getShowFilterScope = (_, props) => props?.showFilterScope

export const getAdjustedNormalizationProperties = createSelector(
  [getIsActive, getSelectedTypeId, getSegment, getNormalization, getShowFilterScope, getEffectiveNormalization],
  (isActive, selectedTypeId, segment, normalization, showFilterScope, effectiveNormalization) => {
    if (isActive && selectedTypeId === "risk" && segment) {
      return {
        normalization: NORMALIZATION.STANDALONE,
        disableNormalization: true,
        disableNormalizationTooltip: "Segment normalization must be Standalone when active",
        isNormalizationAdjusted: true,
      }
    }

    if (!showFilterScope && effectiveNormalization !== normalization) {
      return {
        normalization,
        forcedNormalization: effectiveNormalization,
        disableNormalization: true,
        disableNormalizationTooltip: "Normalization is Standalone here because Filter Scope is set to Full benchmark on another tab, or a tag or attribute filter is applied",
        isNormalizationAdjusted: false,
      }
    }

    return {
      normalization,
      disableNormalization: false,
      isNormalizationAdjusted: false,
    }
  },
)
